import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import Category from '../../entities/extranet/category'
import Ajax from '../../../lib/ajax'
import Util from '../../../lib/util'

interface CategoryState extends ListState<Category>{
    editModel: Category;
}
class CategoryModule extends ListModule<CategoryState,any,Category>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize: 10,
        list: new Array<Category>(),
        loading:false,
        editModel: new Category(),
        activeList: new Array<Category>(),
        path: 'categories'          
    }
    actions = Util.extend(true, this.base_actions, {
        //extra actions
    });
    mutations = Util.extend(true, this.base_mutations, {
        //extra mutations
    });
}
const categoryModule=new CategoryModule();
export default categoryModule;
